import React from 'react';

import topics from '../../models/topics.json';

import {filterTemplateJSON} from '../../tools/tools';
import { text2Html } from '../../tools/textTools.js';

import './glossary.css';

const Glossary = ()=>{


  const columns=[
    'Term',
    'Definition'
  ]

  // const totalCols = columns.length;

  const ths = columns.map(elem=><th className="background-default2" key={elem}>{elem}</th>);

  const topicsFiltered=filterTemplateJSON(topics);

  const topicsHtml=topicsFiltered.map((elem,index)=>{
    // const {mainTitle,category,topics}=elem;
    const {topics}=elem;

    const key="topic_"+index;
    // main title
    // if(mainTitle) {
    //   return <tr key={key}><td className="topics-main-title" colSpan={totalCols}>{mainTitle}</td></tr>
    // }
    // let cat=<td key={key+'_cat'} rowSpan={topics.length}>{category}</td>
    
    const tds=topics.map((elem,indexTopics)=>{
      const {name}=elem;
      let {descr=''}=elem;
      // descr={__html:descr.replace(/\n/g,'<br />')};
      descr=text2Html(descr);
      const ret=(
        <tr key={key+'_'+indexTopics+'_subs'}>
          <td className="topic-list-topic-name"><p className="font-color2">{name}</p></td>
          <td className="font-color2" dangerouslySetInnerHTML={descr}></td>
        </tr>
      )
      // cat=false;
      return ret;
    });

    // return <tr key={key}>{tds}</tr>
    return tds;

  });
  

  return (
    <div className="background-default1 page-content">
      <h2 className="page-title">Glossary</h2>
      <h2 className="page-main-title font-color2">Glossary</h2>
      <p className="page-top-descr font-color2">Check the definition of each topic our system provides automatically:</p>
      <div className="topic-list">
        <table cellSpacing="0">
          <thead>
            <tr>{ths}</tr>
          </thead>
          <tbody>
            {topicsHtml}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Glossary;